
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";
import { Lesson } from "@/lib/types";  // Updated import
import { useTranslation } from "react-i18next";

interface LessonNavigationProps {
  courseSlug: string | undefined;
  prevLesson: Lesson | null;
  nextLesson: Lesson | null;
  isCompleted: boolean;
  onMarkComplete: () => void;
}

export function LessonNavigation({ 
  courseSlug, 
  prevLesson, 
  nextLesson,
  isCompleted,
  onMarkComplete
}: LessonNavigationProps) {
  const { t } = useTranslation();

  return (
    <div className="border-t border-border/40 mt-12 pt-6 grid grid-cols-3">
      <div className="flex justify-start">
        {prevLesson ? (
          <Link
            to={`/courses/${courseSlug}/${prevLesson.moduleSlug}/${prevLesson.slug}`}
            className="flex items-center text-primary hover:underline"
          >
            <ArrowLeft className="mr-2 h-4 w-4" /> {t("previous_lesson")}
          </Link>
        ) : (
          <div />
        )}
      </div>
      
      <div className="flex justify-center">
        <button
          onClick={onMarkComplete}
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm ${
            isCompleted 
              ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300"
              : "bg-primary/10 text-primary hover:bg-primary/20"
          }`}
        >
          {isCompleted ? (
            <>
              <Check className="h-4 w-4" /> {t("completed")}
            </>
          ) : (
            t("mark_complete")
          )}
        </button>
      </div>
      
      <div className="flex justify-end">
        {nextLesson ? (
          <Link
            to={`/courses/${courseSlug}/${nextLesson.moduleSlug}/${nextLesson.slug}`}
            className="flex items-center text-primary hover:underline"
          >
            {t("next_lesson")} <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        ) : (
          <Link
            to={`/courses/${courseSlug}`}
            className="flex items-center text-primary hover:underline"
          >
            {t("finish_course")} <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        )}
      </div>
    </div>
  );
}
